const services = [
  {
    icon: "ri-fire-line",
    title: "HEATING SYSTEMS",
    image: "https://static.readdy.ai/image/36fff7c058435a92029a1d7ae462693c/ccd0c19cbbc97872937b3bacabbcb99c.jpeg",
    snowflake: false,
    description:
      "Furnace installs, boiler replacements, gas fire places, and heat pump retrofits handled by certified technicians. We carry all major brands and back every install with a labor warranty.",
    learnMore: "#heating",
  },
  {
    icon: "ri-snowy-line",
    title: "COOLING & AC",
    image: "https://static.readdy.ai/image/36fff7c058435a92029a1d7ae462693c/f1fc6b45523c2d134fd58da87c0b084b.jpeg",
    snowflake: false,
    description:
      "Central air conditioning, ductless mini-splits, and full HVAC system upgrades that slash energy costs and keep your home perfectly cool all summer.",
    learnMore: "#cooling",
  },
  {
    icon: "ri-leaf-line",
    title: "INDOOR AIR QUALITY",
    image: "https://static.readdy.ai/image/36fff7c058435a92029a1d7ae462693c/90322a9a3797e80406642cce12c33427.jpeg",
    snowflake: false,
    description:
      "Whole-home air purifiers, UV light systems, humidifiers, and smart thermostat installs that improve air quality and reduce allergens year-round.",
    learnMore: "#air-quality",
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-20 bg-[#0B2447]">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14 gap-4 md:gap-6">
          <div>
            <span className="text-[#C8102E] text-xs font-bold tracking-[0.2em] uppercase">OUR SERVICES</span>
            <h2 className="text-2xl md:text-3xl font-extrabold text-white mt-2 leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Ultimate Comfort, Every Season
            </h2>
          </div>
          <p className="text-gray-400 max-w-sm text-sm leading-relaxed">
            From the dead of winter to the heat of summer, Ultimate Heating &amp; Cooling keeps your home running perfectly — licensed, insured, and always on time.
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="relative bg-white/5 border border-white/10 rounded-xl overflow-hidden hover:bg-white/10 hover:border-[#C8102E]/40 transition-all group"
            >
              {/* Service Image or Icon Display */}
              {service.snowflake ? (
                <div className="w-full h-44 flex items-center justify-center bg-gradient-to-br from-[#071a38] via-[#0d2b55] to-[#071a38] relative overflow-hidden">
                  {/* faint background snowflakes */}
                  <i className="ri-snowy-line absolute text-[120px] text-white/5 -bottom-4 -right-4 rotate-12"></i>
                  <i className="ri-snowy-line absolute text-[60px] text-white/5 top-2 left-3 -rotate-12"></i>
                  {/* main snowflake */}
                  <div className="w-20 h-20 flex items-center justify-center bg-[#C8102E]/15 rounded-full group-hover:scale-110 transition-transform duration-500">
                    <i className="ri-snowy-line text-5xl text-[#C8102E]"></i>
                  </div>
                </div>
              ) : (
                <div className="w-full h-44 overflow-hidden">
                  <img
                    src={service.image!}
                    alt={service.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              )}
              {/* Card Body */}
              <div className="p-6 md:p-8">
                <div className="w-11 h-11 flex items-center justify-center mb-5 bg-[#C8102E]/15 rounded-xl">
                  <i className={`${service.icon} text-2xl text-[#C8102E]`}></i>
                </div>
                <h3 className="text-sm font-bold text-white mb-2.5 tracking-widest">{service.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-6">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Stats strip */}
        <div className="mt-12 md:mt-16 grid grid-cols-2 gap-5 md:gap-6 border-t border-white/10 pt-10 md:pt-12">
          {[
            { value: "20+", label: "Years of Experience" },
            { value: "5.0★", label: "Google Rating" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-extrabold text-[#C8102E]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {stat.value}
              </div>
              <div className="text-gray-400 text-xs mt-1 tracking-wide">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
